'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRule = fetchRule;

var _constants = require('../constants');

function fetchRule(ruleId) {
  return {
    type: _constants.FETCH_RULE,
    payload: {
      ruleId: ruleId
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/dear-diary/lib/store/rules/actions/index.js
// module id = 3423
// module chunks = 2